import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.457 22.06c-.623-3.072-1.435-5.923-2.496-8.63-3.412.865-5.972 3.14-8.886 7.117A10.95 10.95 0 0 0 12 23c1.587 0 3.095-.336 4.457-.94m1.38-.735a11 11 0 0 0 5.044-7.7c-2.978-.588-5.379-.742-7.421-.478.994 2.583 1.77 5.29 2.377 8.178M23 12.12V12c0-2.651-.938-5.083-2.5-6.983-1.833 2.115-3.915 3.574-6.585 4.575q.51 1.049.966 2.122c2.31-.359 4.95-.207 8.118.406Zm-3.534-8.2A10.96 10.96 0 0 0 12 1a11 11 0 0 0-3.175.465 47 47 0 0 1 4.405 6.781c2.56-.932 4.505-2.295 6.235-4.326ZM7.358 2.025a11.02 11.02 0 0 0-6.193 8.064c4.467-.214 7.875-.61 10.613-1.378a45.7 45.7 0 0 0-4.42-6.686m-6.35 9.573c4.758-.22 8.46-.641 11.47-1.528q.479.97.906 1.96c-3.754 1.017-6.51 3.552-9.414 7.488a10.96 10.96 0 0 1-2.963-7.92Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandSocialMediaDribbble = { render };
export {
  brandSocialMediaDribbble as default,
  render
};
//# sourceMappingURL=brand-social-media-dribbble.svg.js.map
